import { mkEl } from "../misc/functions";
import { Toast } from "../lib/toast";
import { Stepper } from "../misc/stepper";

declare global {
    interface Document {
        sta_custom_checkout?: CustomCheckout; // or any type you need
        toast?: Toast; // or any type you need
    }
}

interface Upsell {
    title: string;
    qnt: number;
}

interface CustomCheckoutOverview {
    fairs: {
        title: string;
        fairId: string;
        selectedUpsells: Upsell[];
    }[];
    mediaPackages: string[];
}

class CustomCheckout {
    constructor() {
        // this.displayCareeFairOptions();
        this.initEventListeners();
    }

    // displayCareeFairOptions() {
    //     document.querySelector('.career-fairs')?.classList.remove('hidden');
    // }

    initEventListeners() {
        // Array.from(document.querySelectorAll('.career-fairs input[type="checkbox"]')).forEach((checkbox: HTMLInputElement) => {
        //     checkbox.addEventListener('change', () => {
        //         this.toggleUpsellRow(checkbox.dataset.fairId, checkbox.checked)
        //     })
        // })

        Array.from(document.querySelectorAll('.number-input-container.step-1-career-fair-row button'))?.forEach((button: HTMLButtonElement) => {
            button.addEventListener('click', (e: MouseEvent) => {
                // we need a delay because number stepper has delay and it's replacing input fields every 250 ms after click
                setTimeout(() => {
                    e.preventDefault();
                    const input = button.parentNode.querySelector('input') as HTMLInputElement;
                    console.log('input change', input.value);
                    this.toggleUpsellRow(input.id, parseInt(input.value) > 0)
                }, 260)
            })
        })
    }

    toggleUpsellRow(id: string, show: boolean = true) {
        console.log('toggleUpsellRow', id, show);
        document.querySelector(`.sta-upsell-table tbody tr[data-fair-id="${id}"]`)?.classList.toggle('hidden', !show);
        Array.from(document.querySelectorAll(`.sta-upsell-table tbody tr[data-fair-id="${id}"] input`))?.forEach((input: HTMLInputElement) => {
            input.disabled = !show;
        })
    }

    getCheckoutOverview() {
        console.log('CustomCheckout: getCheckoutOverview');
        const selectedProducts: CustomCheckoutOverview = {
            fairs: [],
            mediaPackages: []
        };
        Array.from(document.querySelectorAll('tr.career-fair-row.upsell')).forEach((tr: HTMLElement) => {
            if (tr.classList.contains('hidden')) {
                return;
            }
            const upsellInputs = Array.from(tr.querySelectorAll('input.number-input-text-box'));
            const title = tr.firstElementChild.innerHTML
            const fairId = tr.dataset.fairId;
            const selectedUpsells: Upsell[] = [];

            upsellInputs.forEach((input: HTMLInputElement) => {
                if (parseFloat(input.value) > 0) {
                    selectedUpsells.push({
                        title: input.title,
                        qnt: parseFloat(input.value)
                    })
                }
            })
            selectedProducts.fairs.push({
                title,
                fairId,
                selectedUpsells
            })
        })

        Array.from(document.querySelectorAll('input.media-package-input:checked')).forEach((mediaInput: HTMLInputElement) => {
            selectedProducts.mediaPackages.push(mediaInput.nextElementSibling.innerHTML)
        })

        console.log('selectedProducts', selectedProducts);
        return selectedProducts;
    }

    renderOverview() {
        const selectedProducts: CustomCheckoutOverview = this.getCheckoutOverview();
        const overviewContainer = document.querySelector('.sta-checkout-overview');
        overviewContainer.innerHTML = '';
        overviewContainer.append(mkEl('h2', {
            text: 'Ausgewählte Messstände',
            class: ['wp-block-heading', 'has-xl-font-size']
        }))
        const fairsList = mkEl('ul', { class: ['fairs-list'] });
        selectedProducts.fairs.forEach((fair: CustomCheckoutOverview['fairs'][0]) => {
            const h3 = mkEl('h3', {
                html: fair.title,
                class: ['wp-block-heading', 'is-style-default', 'has-lg-font-size']
            });
            const li = mkEl('li', { append: [h3] });
            fairsList.append(li);
            if (fair.selectedUpsells.length > 0) {
                const upsellList = mkEl('ul', { class: ['upsell-list'] });
                fair.selectedUpsells.forEach((upsell: Upsell) => {
                    upsellList.append(mkEl('li', { append: [mkEl('p', { html: `${upsell.qnt}x ${upsell.title}` })] }))
                })
                li.append(upsellList);
            }
        })

        overviewContainer.append(fairsList);

        // Media

        overviewContainer.append(mkEl('h2', {
            text: 'Ausgewählte Medienpakete',
            class: ['wp-block-heading', 'has-xl-font-size']
        }))
        const ulMedia = mkEl('ul', { class: ['media-list'] });

        if (selectedProducts.mediaPackages.length > 0) {
            selectedProducts.mediaPackages.forEach((mediaPackage: string) => {
                const h3 = mkEl('h3', {
                    html: mediaPackage,
                    class: ['wp-block-heading', 'is-style-default', 'has-lg-font-size']
                });
                const li = mkEl('li', { append: [h3] });
                ulMedia.append(li);
            })
        } else {
            const h3 = mkEl('h3', {
                html: 'Keine',
                class: ['wp-block-heading', 'is-style-default', 'has-lg-font-size']
            });
            const li = mkEl('li', { append: [h3] });
            ulMedia.append(li);
        }
        overviewContainer.append(ulMedia);
    }
}

function initCustomCheckoutActions() {
    const el = document.querySelector(".stepper");
    new Stepper(el);

    console.log("init custom checkout actions");
    document.sta_custom_checkout = new CustomCheckout();
    document.toast = new Toast();
}

window.onload = initCustomCheckoutActions;